// extracted by mini-css-extract-plugin
module.exports = {"trigger":"viewExtras_trigger___VMdV","menu":"viewExtras_menu__D5ibf"};